export default __webpack_public_path__ + "maps-examples-view-annotation-basic-thumbnail-480-e88e28180e45ade5f15bb0f6c66989c2.webp";